<template>
	<div v-loading="thinking">
		<table id="challenge-detail" class="table table-striped table-condensed dt-table" data-name="Challenge Detail">
			<thead>
				<tr>
					<th>Name</th>
					<th>Date Achieved</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in items" :key="item.id">
					<td>{{item.clientName}}</td>
					<td>{{item.dateAchieved}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>

	import { rest } from "@/utilities/rest.js";
	export default {
		name: "challenge-detail",
		data() {
			return {
				items: [],
				thinking: true,
				loaded: false
			}
		},

		props: ["userId", "visible"],

		mounted() {
			if (this.visible) {
				//setTimeout(() => {
					this.fetch();
				//}, 5000);
			}
				
		},

		methods: {
			fetch() {
				rest.get("Account", "/GetChallengeDetail", "json", { userId: this.userId }).done(result => {
					this.items = result;
					let count = 0;
					_.each(this.items, i => {
						i.id = count + 1;
						count = i.id;
					});
					this.loaded = true;
					let vm = this;

					setTimeout(() => {
						this.loadTable();
					}, 0);
					


				}).always(() => {
					//this.thinking = false;
				});
			},

			loadTable() {
				let vm = this;
				$('#challenge-detail').each(function() {

						var $this = $(this),
								name = $this.data("name");
      
      
						$this.DataTable( {
							dom: 'Bfrtip',
							"ordering": false,
							"initComplete": function(settings, json) {
								vm.thinking = false;
							},
							buttons: [ 
								{
									extend: 'pdfHtml5',
									title: name,
									customize: function ( doc ) {
              			doc.content.splice( 1, 0, {
											margin: [ 0, 0, 0, 20 ],
											alignment: 'center',
											image: 'data:image/png;base64, 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'
										});
              
										var idx = doc.content.length - 1;
              
										doc.content[idx].table.widths = Array(doc.content[idx].table.body[0].length + 1).join('*').split('');
              
										var rows = doc.content[idx].table.body;
										for (var i = 0; i < rows.length; i++) {
											var columns = rows[i];
                
											for (var ii = 0; ii < columns.length; ii++) {
												columns[ii].alignment = "left";
												columns[ii].margin = [ 5, 0, 0, 0 ];
											}
										}
              
										doc.footer = {

              				columns: [
											 //'Left part',
											 //{ text: 'Right part', alignment: 'right' }
											]

										}
									}
								}
							]      
						});
      
      
					});
			}
		},

		watch: {
			visible(val) {
				if (val && this.loaded === false) {
					this.fetch();
				}
			}
		}
	}
</script>